var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "element/icon/24/light copy 4@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element/icon/24/light-copy-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1.000000, 0.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5513467,9.49321653 L14.5514535,9.49311095 L14.5500652,9.49226626 C14.3912657,9.37432656 14.2239229,9.26715664 14.0495319,9.17075652 L6.96624403,4.62147287 L6.96592366,4.62210639 C6.24945734,4.13345382 5.38145342,3.84668191 4.44531632,3.84668191 C1.99017237,3.84668191 0,5.81449046 0,8.24180982 C0,9.79719898 0.817811761,11.1627443 2.05083012,11.943976 L2.05008258,11.9450319 L9.29302422,16.5793123 C9.4094273,16.6619863 9.52999527,16.7390641 9.65440774,16.8105459 L9.67427102,16.8232163 L9.67491177,16.822266 C10.3254875,17.1910783 11.0786902,17.4030953 11.8824055,17.4030953 C14.3375494,17.4030953 16.3277218,15.4352867 16.3277218,13.0079674 C16.3277218,11.5709402 15.6299441,10.2951431 14.5513467,9.49321653 Z",
    id: "Stroke-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3277005,13.0079779 C16.3277005,15.4352973 14.3375281,17.4030002 11.8824909,17.4030002 C9.42734697,17.4030002 7.4371746,15.4352973 7.4371746,13.0079779 C7.4371746,10.5806586 9.42734697,8.61285001 11.8824909,8.61285001 C14.3375281,8.61285001 16.3277005,10.5806586 16.3277005,13.0079779 Z",
    id: "Stroke-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.8824375,
    y1: 20.0147574,
    x2: 11.8824375,
    y2: 23,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.87130611,
    y1: 17.96248,
    x2: 5.02113921,
    y2: 19.780468,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.7437358,
    y1: 6.23538226,
    x2: 16.893569,
    y2: 8.05337027,
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 13.0079779,
    x2: 18.9692495,
    y2: 13.0079779,
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.7437358,
    y1: 19.7805208,
    x2: 16.893569,
    y2: 17.9625328,
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L3,5.40387137 C3,5.88103356 3.67166252,6.26791255 4.5000868,6.26791255 C5.32851108,6.26791255 6,5.88103356 6,5.40387137 L6,0 L3,0 Z",
    id: "Stroke-17",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLights);
export default __webpack_public_path__ + "static/media/icon-lights.d874809f6bd86ab8ec1e1d0a0f17ce6d.svg";
export { ForwardRef as ReactComponent };